import React from 'react';
import { Container, Typography } from "@mui/material"
import { AttendanceDataTable } from './AttendanceDataTable';

export const AttendanceHomePage = () => {
  return (
    <Container disableGutters>
      <Typography variant="h5" mt={2} mb={5}>Attendance</Typography>
      <AttendanceDataTable />
    </Container>
  )
}